import Modal from "react-bootstrap/Modal";
import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import IconSvg from "../../../SharedComponents/IconSvg";
import { SetStartInfoModalIsShown } from "../Store";
import Button from "react-bootstrap/Button";
import { applicationTypeEnum, GetKeyByValue } from "../../../../Helpers/EnumHelper";
import { useNavigate } from "react-router-dom";
import { EnterFullscreen, ExitFullscreen } from "../../../../Helpers/FullscreenHelper";
import Webcam from "react-webcam";
import { useTranslation } from "react-i18next";

const StartInfoModal = ({ selectedAssessment, setSelectedAssessment }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);

  const isShown = useSelector((state) => state.userDash.startInfoModalIsShown);

  const [extraScreens, setExtraScreens] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isPreviewingCamera, setIsPreviewingCamera] = useState(false);
  const [isCameraLive, setIsCameraLive] = useState(false);
  const [hasCamera, setHasCamera] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState("prompt");
  const [permissionHelperIsShown, setPermissionHelperIsShown] = useState(false);

  const videoRef = useRef();

  useEffect(() => {
    if (!isShown) {
      setIsPreviewingCamera(false);
      setIsCameraLive(false);
      setPermissionStatus("prompt");
    }
  }, [isShown]);

  useEffect(() => {
    if (isShown) {
      detectExtraScreens();
    }

    const interval = setInterval(detectExtraScreens, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [isShown, selectedAssessment]);

  useEffect(() => {
    const interval = setInterval(() => {
      checkIfCameraIsLive();
    }, 500);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      checkCameraHardwareAvailability().then((result) => {
        if (!result.hasCamera) {
          setIsPreviewingCamera(false);
        }
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      checkCameraPermissionStatus().then((result) => {
        if (result.permission !== "granted") {
          setIsPreviewingCamera(false);
        }
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (permissionStatus === "granted" || !hasCamera || permissionStatus === "prompt") {
      setPermissionHelperIsShown(false);
    } else {
      setPermissionHelperIsShown(true);
    }
  }, [permissionStatus, hasCamera]);

  const checkIfCameraIsLive = () => {
    const videoEl = videoRef.current?.video || videoRef.current;
    const stream = videoEl?.srcObject;

    if (!stream) {
      setIsCameraLive(false);
      return;
    }

    const track = stream.getVideoTracks()[0];
    setIsCameraLive(track && track.readyState === "live");
  };
  //TODO: kamera olmayan bilgisayarda test et
  const checkCameraPermissionStatus = async () => {
    try {
      const permissionResult = await navigator.permissions.query({ name: "camera" });

      setPermissionStatus(permissionResult.state); // "granted", "denied", or "prompt"

      // Optionally listen for permission changes
      permissionResult.onchange = () => {
        setPermissionStatus(permissionResult.state);
      };

      return { status: "ok", permission: permissionResult.state };
    } catch (e) {
      console.warn("Error while checking camera permission:", e);
      setPermissionStatus("error");
      return { status: "error", message: e.message };
    }
  };
  const checkCameraHardwareAvailability = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((device) => device.kind === "videoinput");

      const hasCamera = videoDevices.length > 0;
      setHasCamera(hasCamera);
      if (!hasCamera) {
        setIsPreviewingCamera(false);
      }
      return { status: "ok", hasCamera };
    } catch (e) {
      console.warn("Error while checking camera hardware:", e);
      setHasCamera(false);
      return { status: "error", message: e.message };
    }
  };

  const startCamera = () => {
    setIsPreviewingCamera(true);

    checkCameraPermissionStatus().then((result) => {
      if (result.status === "ok") {
        if (result.permission === "granted") {
          setIsPreviewingCamera(true);
        } else {
          setIsPreviewingCamera(false);
        }
      }
    });
  };

  const detectExtraScreens = () => {
    if (window.screen.isExtended) {
      setExtraScreens(true);
    } else {
      setExtraScreens(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Detect F11 keypress (keyCode 122 or "F11")
      if (event.key === "F11" || event.keyCode === 122) {
        event.preventDefault(); // Prevent default F11 browser behavior
        EnterFullscreen();
      }
    };

    const checkFullscreenStatus = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("fullscreenchange", checkFullscreenStatus); // Detect F11

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("fullscreenchange", checkFullscreenStatus); // Detect F11
    };
  }, []);

  const HandleStart = (application, ticketId) => {
    switch (application.applicationType) {
      case applicationTypeEnum.Inventory:
        navigate("/invapp/" + application.id + "/" + ticketId, {
          state: { clickCounter: application.sessionsData?.clickCounter },
        });
        break;
      case applicationTypeEnum.Test:
        navigate("/testapp/" + application.id + "/" + ticketId, {
          state: { clickCounter: application.sessionsData?.clickCounter },
        });
        break;
      default:
        alert("Uygulama bilgileri eksik, lütfen yetkili ile iletişime geçin.");
        break;
    }
    dispatch(SetStartInfoModalIsShown(false));
  };
  const isDisabledBecauseCamera =
    !isCameraLive &&
    selectedAssessment?.application.applicationType === applicationTypeEnum.Test &&
    selectedAssessment?.application?.openCam;

  const isCameraRequired =
    selectedAssessment?.application.applicationType === applicationTypeEnum.Test &&
    selectedAssessment?.application?.openCam;

  const isDisabledBecauseExtraScreens =
    extraScreens &&
    selectedAssessment?.application.preventCheating &&
    selectedAssessment?.application.applicationType === applicationTypeEnum.Test;

  const isDisabledBecauseFullscreen =
    !isFullscreen &&
    selectedAssessment?.application.preventCheating &&
    selectedAssessment?.application.applicationType === applicationTypeEnum.Test;
  const isCheatingPreventionEnabled =
    selectedAssessment?.application.preventCheating &&
    selectedAssessment?.application.applicationType === applicationTypeEnum.Test;

  // const isOnlyFullscreenDisabled =
  //   isDisabledBecauseFullscreen && !isDisabledBecauseExtraScreens && !isDisabledBecauseCamera;

  const isCameraORFullScreenDisabled =
    (isDisabledBecauseFullscreen || isDisabledBecauseCamera) && !isDisabledBecauseExtraScreens;

  return (
    <>
      <Modal
        size={"lg"}
        dialogClassName={`custom-modal-dialog ${windowSizeCssClass}`}
        contentClassName={"custom-modal-content"}
        show={isShown}
        onHide={() => {
          dispatch(SetStartInfoModalIsShown(false));
          setSelectedAssessment(null);
          ExitFullscreen();
        }}
      >
        <div className={"bordered text-18"}>
          <Modal.Header closeButton className={"p-0 border-bottom-0"}></Modal.Header>

          {isCheatingPreventionEnabled && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"monitorOff"}></IconSvg>
              </Col>
              <Col>
                {t("multipleMonitorStartInfoPrefix")}
                <span style={{ fontWeight: 600 }}>{t("MULTIPLE MONITORS")}</span> {t("multipleMonitorStartInfoSuffix")}
              </Col>
            </Row>
          )}
          {isCheatingPreventionEnabled && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"fullscreen"}></IconSvg>
              </Col>
              <Col>
                {t("fullscreenStartInfoPrefix")} <span style={{ fontWeight: 600 }}>{t("FULLSCREEN")} </span>{" "}
                {t("fullscreenStartInfoSuffix")}
              </Col>
            </Row>
          )}
          {isCheatingPreventionEnabled && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"closeTabs"}></IconSvg>
              </Col>
              <Col>
                {t("switchTabStartInfoPrefix")} <span style={{ fontWeight: 600 }}>{t("SWITCH TABS")}</span>{" "}
                {t("switchTabStartInfoSuffix")}
              </Col>
            </Row>
          )}

          {selectedAssessment?.application?.duration && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"clock"}></IconSvg>
              </Col>
              <Col>
                {t("durationStartInfoPrefix")}
                <span
                  style={{
                    fontWeight: 600,
                  }}
                >
                  {selectedAssessment?.application?.sessionsData?.remainingDuration
                    ? Math.floor(selectedAssessment.application.sessionsData.remainingDuration / 60)
                    : Math.floor(selectedAssessment.application.duration / 60)}{" "}
                  {t("minutes")}
                </span>{" "}
                {t("durationStartInfoSuffix")}
              </Col>
            </Row>
          )}
          {isCameraRequired && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"webcamEnabled"}></IconSvg>
              </Col>
              <Col>
                {t("webcamEnabledStartInfoPrefix")}
                <span
                  style={{
                    color: "#0f0",
                    fontWeight: 600,
                  }}
                >
                  {t("ENABLED")}
                </span>
                {t("webcamEnabledStartInfoSuffix")}
              </Col>
            </Row>
          )}

          {/*{isCheatingPreventionEnabled && (
            <Row className={"mb-3"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"webcamDisabled"}></IconSvg>
              </Col>
              <Col>
                {t("microphoneEnabledStartInfoPrefix")}
                <span
                  style={{
                    color: "#0f0",
                    fontWeight: 600,
                  }}
                >
                  {t("ENABLED")}
                </span>
                {t("microphoneEnabledStartInfoSuffix")}
              </Col>
            </Row>
          )}*/}
          {/*

          {!selectedAssessment?.company?.hasDemography && (
            <Row className={"mb-5"}>
              <Col xs={"auto"} className={"align-content-center"}>
                <IconSvg icon={"infoButton"}></IconSvg>
              </Col>
              <Col>
                You have to fill in your <span style={{ fontWeight: 600 }}>DEMOGRAPHIC INFORMATION</span> in the first
                part of the assessment
              </Col>
            </Row>
          )}
*/}

          <Row className={"justify-content-end"}>
            {isCameraRequired && (
              <Col>
                {isShown && isPreviewingCamera ? (
                  <Webcam height={112} audio={false} ref={videoRef}></Webcam>
                ) : (
                  <div
                    className={"bg-dark-subtle text-center align-content-center"}
                    style={{ height: "120px", width: "160px" }}
                  >
                    {hasCamera ? t("startInfoCameraUnreachable") : t("startInfoCameraNotPresent")}
                  </div>
                )}
              </Col>
            )}

            {(!isCameraLive && isCameraRequired && !isDisabledBecauseExtraScreens && (
              <Col key={"camOpenButtonCol"} xs={"auto"} className={"align-content-end"}>
                <Button
                  className={"button primary"}
                  disabled={!hasCamera}
                  onClick={() => {
                    startCamera();
                  }}
                >
                  {hasCamera ? t("startInfoStartCameraButton") : t("startInfoDeviceNotAvailableButton")}
                </Button>
              </Col>
            )) ||
              (isDisabledBecauseFullscreen && !isDisabledBecauseExtraScreens && (
                <Col key={"goFullscreenButtonCol"} xs={"auto"} className={"align-content-end"}>
                  <Button
                    className={"button primary"}
                    onClick={() => {
                      EnterFullscreen();
                    }}
                  >
                    {t("startInfoGoToFullscreen")}
                  </Button>
                </Col>
              ))}

            {!isCameraORFullScreenDisabled && (
              <Col xs={"auto"} className={"align-content-end"}>
                <Button
                  disabled={isDisabledBecauseExtraScreens || isDisabledBecauseCamera || isDisabledBecauseFullscreen}
                  className="button secondary"
                  onClick={() => {
                    HandleStart(selectedAssessment?.application, selectedAssessment?.ticketId);
                  }}
                >
                  {(isDisabledBecauseExtraScreens && t("startInfoPleaseRemoveMonitors")) ||
                    (isDisabledBecauseCamera && t("startInfoPleaseAllowCamera")) ||
                    (isDisabledBecauseFullscreen && t("startInfoPleaseGoToFullscreen"))}
                  {!isDisabledBecauseExtraScreens &&
                    !isDisabledBecauseFullscreen &&
                    !isDisabledBecauseCamera &&
                    t("startInfoStartAssessmentPrefix") +
                      ` ${t(GetKeyByValue(selectedAssessment?.application?.applicationType, applicationTypeEnum))}` + //dynamic translation here, Inventory, Test, Survey
                      t("startInfoStartAssessmentSuffix")}
                </Button>
              </Col>
            )}
          </Row>
        </div>
      </Modal>
      {permissionHelperIsShown &&
        isShown &&
        ReactDOM.createPortal(
          <div className="position-absolute " style={{ top: "0px", left: "160px", zIndex: "1055" }}>
            <Row className={"mx-0"}>
              <Col xs={"auto"} className={"px-0"}>
                <IconSvg icon={"top-left-curly-arrow"} height={150} width={150}></IconSvg>
              </Col>
              <Col xs={"auto"} className={"px-0 fw-bold"} style={{ marginTop: "110px" }}>
                <Row>
                  <Col>
                    <div className={"permission-helper"}>
                      {t("startInfoAllowPermissionsPortal")} {permissionStatus}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>,
          document.getElementById("permission-portal")
        )}
    </>
  );
};
export default StartInfoModal;
